import { render, staticRenderFns } from "./Launch.vue?vue&type=template&id=edfe4e14&scoped=true"
import script from "./Launch.vue?vue&type=script&lang=ts"
export * from "./Launch.vue?vue&type=script&lang=ts"
import style0 from "./Launch.vue?vue&type=style&index=0&id=edfe4e14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfe4e14",
  null
  
)

export default component.exports